var QUOTE = `"`;
var COMMA = ",";
var LF = "\n";
var CR = "\r";

var parse = function(csv) {
  var quoting = false;
  var output = [];
  var line = [];
  var buffer = "";
  var index = 0;
  for (var i = 0; i < csv.length; i++) {
    var char = csv[i];
    var next = csv[i+1];
    if (quoting) {
      if (char == QUOTE) {
        if (next == QUOTE) {
          i++;
          buffer += char;
        } else {
          quoting = false;
        }
      } else {
        if (char == CR || char == LF) throw new Error(`Line ended early on ${index}`);
        buffer += char;
      }
    } else {
      switch (char) {
        case COMMA:
          line.push(buffer);
          buffer = "";
        break;

        case CR:
        case LF:
          if (buffer.length) line.push(buffer);
          if (line.length) output.push(line);
          buffer = "";
          line = [];
        break;

        case QUOTE:
          quoting = true;
        break;

        default:
          buffer += char;
      }
    }
  }
  if (quoting) throw new Error("File ended early!");
  if (buffer.length) line.push(buffer);
  if (line.length) output.push(line);
  return output;
}

module.exports = { parse };